/**
 * Created by Mark on 04/05/2017.
 */



import React   from 'react';

import {ProgressBar, Row, Col , Card} from 'react-bootstrap';
import Profile from '../../profile/homework-profile-library';
import AssignmentService from '../../../services/assignments-service';
import UserStore from '../../../store/user-store';
import UserService from '../../../services/user-service';
import ClassesService from '../../../services/classes-service';
import VocabPanel from '../../profile/profile-tabs/new_homework/vocabs-panel';
import CustomPanel from '../../profile/profile-tabs/new_homework/custom-panel';
import SentencePanel from '../../profile/profile-tabs/new_homework/sentence-panel';
import VerbPanel from '../../profile/profile-tabs/new_homework/verb-panel';
import GrammarPanel from '../../profile/profile-tabs/new_homework/grammar-panel';
import ExamPanel from '../../profile/profile-tabs/new_homework/exam-panel';
import Favourite from '../../favorite_button.js';
import Translation from '../../../store/internationalization-store.js';
import Constants from '../../../constants.js';

export default class HomeworkLibraryOverview extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            homework:{'name':"homework name"},
            hasLoaded:false
        }
        this.steps = [];
    }

    componentDidMount(){
        UserService.getAssignments();
        UserService.getArchivedAssignments();
    }

    componentWillMount(){

        var homeworks = UserStore.archived;
        for(var key in homeworks) {
            if(!homeworks.hasOwnProperty(key)) {
                continue;
            } else if (homeworks[key].id == this.props.homeworkID) {
                this.setState({homework:homeworks[key], hasLoaded:true})
                break;
            }
        }

        var homeworks = UserStore.assignments;
        for(var key in homeworks) {
            if(!homeworks.hasOwnProperty(key)) continue;
            if(homeworks[key].id == this.props.homeworkID)
            {
                this.setState({homework:homeworks[key], hasLoaded:true})
                break;
            }
        }

        UserStore.on(Constants.GET_MY_ASSIGNMENTS, function() {
            var homeworks = UserStore.assignments;
            for(var key in homeworks) {
                if(!homeworks.hasOwnProperty(key)) continue;
                if(homeworks[key].id == this.props.homeworkID)
                {
                    this.setState({homework:homeworks[key], hasLoaded:true})
                    break;
                }

            }
        }.bind(this));

        UserStore.on(Constants.GET_MY_ARCHIVED_ASSIGNMENTS , () => {
            var homeworks = UserStore.archived;
            for(var key in homeworks) {
                if(!homeworks.hasOwnProperty(key)) {
                   continue;
                } else if (homeworks[key].id == this.props.homeworkID) {
                    this.setState({homework:homeworks[key], hasLoaded:true})
                    break;
                }
            }
        });
        
        AssignmentService.getHomeworkFeatures(this.props.homeworkID).then(function(response){
            for(var idx = 0; idx < response.length; idx++){

                var feature = response[idx];
                switch(String(feature.uid))
                {
                    
                    case "1" : this.steps = this.steps.concat([VocabPanel]); break;
                    case "2" : this.steps = this.steps.concat([SentencePanel]); break;
                    case "3" : this.steps = this.steps.concat([VerbPanel]); break;
                    case "4" : this.steps = this.steps.concat([GrammarPanel]); break;
                    case "5" : this.steps = this.steps.concat([ExamPanel]); break;
                    case "6" : this.steps = this.steps.concat([CustomPanel]); break;
                    
                }
            }

            this.setState({
                features:response
            });

        }.bind(this));
    }

    updateFav(toggle){
        ClassesService.updateFav((toggle == "1" || toggle == true) ? "1" : "0" , this.props.homeworkID, this.props.curriculumID);
    }

    render(){
        if (this.state.hasLoaded == false) {
            return <ProgressBar animated progress={45}/>;
        }

        return (<div>
            <Row>
                <Col sm={12} md={12}>
                            <Row>
                                <Col md={11}><Card.Title><b>{this.state.homework.name}</b></Card.Title>
                                </Col><Col md={1}><center onClick={function() {
                                        //this.state.homework.favourite = !this.state.homework.favourite;
                                        //this.updateFav(this.state.homework.favourite)
                                    }.bind(this)}><Favourite stopToggle={true} toggle={this.state.homework.favourite == "1"} /></center></Col>
                            </Row>
                            <Row>
                                <Col md={12}><Card.Title>
                                    <hr/>
                                    <small>{Translation.get(2203 , 'Description')}: </small><small>{this.state.homework.description}</small></Card.Title></Col>
                                <br/>
                            </Row>

                    <Profile edit={this.state.homework.edit} id={this.props.homeworkID} curriculumID={this.props.curriculumID} 
                            archive={()=>{this.setState({showArchived:true})}} delete={()=>{this.setState({showDeleted:true})}} 
                            data={{homework:this.state.homework , homeworkID:this.props.homeworkID}}
                            panels={ this.steps}/>
                    </Col>
            </Row>
                </div>);
    }
}